import React from 'react'
import PropTypes from 'prop-types'

import ParameterValue from 'components/ParameterValue'
import { Paragraph } from 'components/patterns/Typography'

import withStyle from './ReadOnlyPatamenterValue.style'

const ReadOnlyParameterValue = ({
  label,
  value,
  className,
  noValueText,
  noColon,
}) => (
  <Paragraph size="small" className={className}>
    <ParameterValue
      label={label}
      value={value}
      noValueText={noValueText}
      noColon={noColon}
      size="small"
    />
  </Paragraph>
)

export default withStyle(ReadOnlyParameterValue)

ReadOnlyParameterValue.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  noValueText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  className: PropTypes.string,
  noColon: PropTypes.bool,
}
